import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import { openModal } from '../../redux/modal';
import Link from '@/components/atoms/Link';
import { getResultData, getApiDataRequest, performApiRequest, invalidateApiDataRequest } from '../../redux/apiData';
import PriceTag from '../shared/designElements/PriceTag';
import ButtonSecondary from '../shared/buttons/ButtonSecondary';
import MakeWishListIcon from '../shared/icons/MakeWishList';
import FavoriteIcon from '../shared/icons/Favorite';
import PlusIcon from '../shared/icons/Plus';
import WidgetHeader from '../shared/designElements/WidgetHeader';
import { WidgetScroller } from '../shared/designElements/WidgetScroller';
import { WidgetFooter } from '../shared/designElements/WidgetFooter';
import ImageLoader from '../shared/ui/ImageLoader';
import formatPrice from '../../services/formatPrice';
import { fromBreakpoint } from '../../styles/breakpoints';
import { colorPalette, fonts, textStyles } from '../../styles/styleGuide';
import getLinkFromPageObject from '../../services/getLinkFromPageObject';
import get from 'lodash.get';
import onNetworkStatusChange from '@/processes/onNetworkStatusChange';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'user', {}),
    phase: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'phase'),
    postWishListRequest: getApiDataRequest(state.apiData, 'postWishList', {
      projectSlug: String(ownProps.match.params.projectSlug)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    handleClick: function handleClick(evt, priceListBlockId, phase, user) {
      evt.preventDefault();
      if (phase === 'cj1') {
        dispatch(openModal(colorPalette.beige, {
          type: 'pricelist',
          componentProps: {
            projectSlug: String(projectSlug),
            priceListBlockId: priceListBlockId
          }
        }));
      } else {
        // immediately start a new design for house that customer is bound to
        dispatch(performApiRequest('postWishList', {
          projectSlug: String(projectSlug)
        }, {
          house: user.customer && user.customer.houseId
        }));
      }
    },
    invalidateData: function invalidateData() {
      dispatch(invalidateApiDataRequest('getWishLists', {
        projectSlug: String(projectSlug)
      }));
      dispatch(invalidateApiDataRequest('postWishList', {
        projectSlug: String(projectSlug)
      }));
    },
    openExplanationModal: function openExplanationModal(evt) {
      evt.preventDefault();
      dispatch(openModal(colorPalette.lightOrange, {
        type: 'deleteWishList',
        componentProps: {
          type: 'confirmation'
        }
      }));
    }
  };
};
var DesignsWidget = /*#__PURE__*/function (_Component) {
  function DesignsWidget() {
    var _this;
    _classCallCheck(this, DesignsWidget);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DesignsWidget, [].concat(args));
    _defineProperty(_this, "state", {
      onHover: false
    });
    return _this;
  }
  _inherits(DesignsWidget, _Component);
  return _createClass(DesignsWidget, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        match = _this$props.match,
        router = _this$props.router,
        postWishListRequest = _this$props.postWishListRequest,
        invalidateData = _this$props.invalidateData;
      var projectSlug = match.params.projectSlug;
      if (postWishListRequest && postWishListRequest.networkStatus === 'success') {
        router === null || router === void 0 || router.push("/".concat(String(projectSlug), "/closed/homestudio/").concat(String(postWishListRequest.result)));
      }
      onNetworkStatusChange({
        onSucces: invalidateData
      }, prevProps.postWishListRequest, postWishListRequest);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        match = _this$props2.match,
        wishlist = _this$props2.wishlist,
        phase = _this$props2.phase,
        user = _this$props2.user,
        openExplanationModal = _this$props2.openExplanationModal,
        handleClick = _this$props2.handleClick;
      var projectSlug = match.params.projectSlug;
      var whislistCount = wishlist.wishlists.length;
      var ownBNR = get(user, 'customer.bnr', undefined);
      return __jsx(Fragment, null, __jsx(WidgetHeader, {
        title: "Woonontwerpen ".concat(whislistCount > 0 ? "(".concat(whislistCount, ")") : ''),
        "data-id": "dashboard_DesignsWidget_WidgetHeader"
      }), __jsx(WidgetScroller, {
        "data-id": "dashboard_DesignsWidget_WidgetScroller"
      }, whislistCount > 0 ? __jsx(Collection, {
        "data-id": "dashboard_DesignsWidget_Collection"
      }, wishlist.wishlists.slice(0, 3).map(function (wishlist, index) {
        return __jsx(WishList, {
          key: index,
          notAvailable: ownBNR ? wishlist.house.status === 'sold' && wishlist.house.hasCustomer && wishlist.house.bnr !== ownBNR : wishlist.house.status === 'sold' && wishlist.house.hasCustomer,
          "data-id": "dashboard_DesignsWidget_WishList"
        }, __jsx(LinkElement, {
          "data-e2e-dashboard-designs-widget": true,
          href: "/".concat(String(projectSlug), "/closed/homestudio/").concat(wishlist.id),
          onClick: (ownBNR ? wishlist.house.status === 'sold' && wishlist.house.hasCustomer && wishlist.house.bnr !== ownBNR : wishlist.house.status === 'sold' && wishlist.house.hasCustomer) ? openExplanationModal : undefined,
          "data-id": "dashboard_DesignsWidget_LinkElement"
        }, __jsx(ImageContainer, {
          notAvailable: ownBNR ? wishlist.house.status === 'sold' && wishlist.house.hasCustomer && wishlist.house.bnr !== ownBNR : wishlist.house.status === 'sold' && wishlist.house.hasCustomer,
          "data-id": "dashboard_DesignsWidget_ImageContainer"
        }, __jsx(ImageLoader, {
          src: get(wishlist, 'image.image.src'),
          mode: "bg",
          alt: wishlist.house.variantCode,
          "data-id": "dashboard_DesignsWidget_ImageLoader"
        }), !(ownBNR ? wishlist.house.status === 'sold' && wishlist.house.hasCustomer && wishlist.house.bnr !== ownBNR : wishlist.house.status === 'sold' && wishlist.house.hasCustomer) && __jsx(FavoriteIcon, {
          filled: wishlist.isFavorite,
          "data-id": "dashboard_DesignsWidget_FavoriteIcon"
        }), wishlist.house.status === 'sold' && __jsx(PriceTagContainer, {
          "data-id": "dashboard_DesignsWidget_PriceTagContainer"
        }, !wishlist.house.hasCustomer && __jsx(PriceTag, {
          isSold: true,
          mini: true,
          "data-id": "dashboard_DesignsWidget_PriceTag"
        }), (ownBNR ? wishlist.house.status === 'sold' && wishlist.house.hasCustomer && wishlist.house.bnr !== ownBNR : wishlist.house.status === 'sold' && wishlist.house.hasCustomer) && __jsx("div", {
          "data-id": "dashboard_DesignsWidget_div"
        }, __jsx("p", {
          "data-id": "dashboard_DesignsWidget_p"
        }, "NIET MEER BESCHIKBAAR")))), __jsx(InfoContainer, {
          "data-id": "dashboard_DesignsWidget_InfoContainer"
        }, __jsx(TitleSmall, {
          "data-id": "dashboard_DesignsWidget_TitleSmall"
        }, wishlist.title), __jsx(Description, {
          "data-id": "dashboard_DesignsWidget_Description"
        }, "Ontwerp voor bouwnummer ", wishlist.house.bnr), __jsx(Price, {
          "data-id": "dashboard_DesignsWidget_Price"
        }, __jsx(PriceTag, {
          price: wishlist.price,
          isSold: wishlist.house.status === 'sold',
          "data-id": "dashboard_DesignsWidget_PriceTag"
        })), __jsx(Caption, {
          "data-id": "dashboard_DesignsWidget_Caption"
        }, "Dit bedrag is inclusief", ' ', formatPrice(Number(wishlist.totals.userWishTotal), {
          showDecimal: true
        }), ' ', "aan eigen woonwensen"))));
      })) : __jsx(MakeWishlist, {
        onClick: function onClick(evt) {
          return handleClick(evt, wishlist.priceListBlockId, phase, user);
        },
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            onHover: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            onHover: false
          });
        },
        "data-id": "dashboard_DesignsWidget_MakeWishlist"
      }, __jsx(CTAContainer, {
        "data-id": "dashboard_DesignsWidget_CTAContainer"
      }, __jsx(MakeWishListIcon, {
        color: this.state.onHover ? colorPalette.darkBlue : colorPalette.lightBlue,
        colorBrush: this.state.onHover ? colorPalette.darkBlue : colorPalette.blue,
        "data-id": "dashboard_DesignsWidget_MakeWishListIcon"
      }), __jsx(CreateCTA, {
        onHover: this.state.onHover,
        "data-id": "dashboard_DesignsWidget_CreateCTA"
      }, __jsx(Icon, {
        onHover: this.state.onHover,
        "data-id": "dashboard_DesignsWidget_Icon"
      }, __jsx(PlusIcon, {
        "data-id": "dashboard_DesignsWidget_PlusIcon"
      })), "Maak een nieuw woonontwerp")))), wishlist.link && whislistCount > 0 && __jsx(WidgetFooter, {
        "data-id": "dashboard_DesignsWidget_WidgetFooter"
      }, __jsx(ButtonSecondary, {
        label: "Woonontwerpen beheren",
        type: "internalLink",
        route: '/' + getLinkFromPageObject(wishlist.link),
        "data-id": "dashboard_DesignsWidget_ButtonSecondary"
      })));
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(DesignsWidget));
var CTAContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n\n  #makeWishListOutline,\n  #makeWishListBrush {\n    transition: all 0.2s ease-in-out;\n  }\n"])));
var CreateCTA = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  width: 100%;\n  text-align: center;\n  ", ";\n  font-weight: bold;\n  text-decoration: none;\n  color: ", ";\n  transition: color 0.2s ease-in-out;\n  align-items: center;\n  justify-content: center;\n  margin-top: 45rem;\n\n  ", ";\n"])), textStyles.bodyText, function (props) {
  return props.onHover ? colorPalette.darkBlue : colorPalette.blue;
}, fromBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-top: 70rem;\n  "]))));
var Icon = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 26rem;\n  height: 26rem;\n  background-color: ", ";\n  transition: background-color 0.2s ease-in-out;\n  box-sizing: border-box;\n  padding: 7rem;\n  margin-right: 12rem;\n  border-radius: 50%;\n"])), function (props) {
  return props.onHover ? colorPalette.darkBlue : colorPalette.lightBlue;
});
var MakeWishlist = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  border: 1rem dashed ", ";\n  box-sizing: border-box;\n  background-color: #ffffff;\n  width: 100%;\n  min-height: 260rem;\n  margin-bottom: 20rem;\n  cursor: pointer;\n  display: flex;\n  align-item: center;\n  justify-content: center;\n\n  ", ";\n"])), colorPalette.lightBeige, fromBreakpoint.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    min-height: 392rem;\n  "]))));
var ImageContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 150rem;\n  height: 85rem;\n  margin-bottom: 15rem;\n  margin-right: 20rem;\n  position: relative;\n  overflow: hidden;\n\n  &:after {\n    content: '';\n    opacity: 0.1;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);\n  }\n\n  > svg {\n    position: absolute;\n    z-index: 1;\n    top: 10rem;\n    right: 10rem;\n  }\n\n  > div {\n    transition: transform 0.45s ease-in-out;\n    transform: scale(1);\n    &:nth-of-type(1) {\n      filter: ", ";\n    }\n  }\n\n  ", ";\n"])), function (props) {
  return props.notAvailable ? 'contrast(40%)' : 'contrast(100%)';
}, fromBreakpoint.md(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n  "]))));
var PriceTagContainer = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  ", ";\n  font-weight: bold;\n  color: white;\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    > p {\n      margin-top: 0;\n      text-align: center;\n      margin-bottom: 0;\n      font-size: 12rem;\n      max-width: 100rem;\n    }\n  }\n"])), textStyles.caption);
var LinkElement = styled(Link)(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  text-decoration: none;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", ";\n\n  ", ";\n\n  &:hover {\n    ", " > div {\n      transform: scale(1.1);\n    }\n  }\n"])), fromBreakpoint.md(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: flex-start;\n  "]))), fromBreakpoint.xl(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    padding-right: 130rem;\n  "]))), ImageContainer);
var InfoContainer = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n"])), fromBreakpoint.md(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    padding-right: 120rem;\n  "]))));
var TitleSmall = styled.h4(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  margin-top: 0;\n  margin-bottom: 10rem;\n  color: ", ";\n  font-weight: bold;\n  font-size: 18rem;\n  line-height: 26rem;\n"])), fonts.primary, colorPalette.orange);
var Description = styled.p(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-size: 14rem;\n  line-height: 20rem;\n  color: ", ";\n  font-family: ", ";\n  margin-top: 0;\n  margin-bottom: 10rem;\n"])), colorPalette.textGrey, fonts.primary);
var Price = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  margin-bottom: 8rem;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 10rem;\n    right: 0;\n  "]))));
var Caption = styled.span(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-style: italic;\n  font-size: 12rem;\n  line-height: 16rem;\n  color: ", ";\n  display: block;\n"])), fonts.primary, colorPalette.beige);
var Collection = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  min-height: 210rem;\n  overflow: hidden;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    min-height: 190rem;\n  "]))));
var WishList = styled.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  border-top: 1rem dashed ", ";\n  padding: 15rem 0;\n  filter: ", ";\n\n  &:last-of-type {\n    border-bottom: 1rem dashed ", ";\n    margin-bottom: 60rem;\n  }\n"])), colorPalette.lightBeige, function (props) {
  return props.notAvailable ? 'grayscale(100%)' : 'grayscale(0%)';
}, colorPalette.lightBeige);